// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WRxWZ69Tv5BhAg {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-basis: 272px;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: start;
  justify-content: space-between;
  width: 272px;
  max-height: 100%;
  padding-bottom: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--accent-background, var(--tr-background-list));
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  vertical-align: top;
  white-space: normal;
  scroll-margin: 8px;
  padding-bottom: var(--ds-space-0, 0);
  border-radius: var(--ds-border-radius-300, 10px);
  background: linear-gradient(98deg, var(--ds-background-brand-bold, #0c66e4) 0%, var(--ds-background-accent-blue-subtle, #579dff) 97.25%);
}
@media only screen and (max-width: 750px) {
  .WRxWZ69Tv5BhAg {
    scroll-snap-align: center;
  }
}
@media print {
  .WRxWZ69Tv5BhAg {
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    margin-bottom: 16px;
  }
}
.WRxWZ69Tv5BhAg.X5QPAOfAK091Eq {
  flex-basis: auto;
  width: auto;
  max-width: fit-content;
  padding-bottom: var(--ds-space-0, 0);
}
.WRxWZ69Tv5BhAg.hsPrekSiQjIA0C {
  outline: 2px solid var(--ds-border-focused, #388bff);
}
.mac .WRxWZ69Tv5BhAg.hsPrekSiQjIA0C {
  outline-color: -webkit-focus-ring-color;
}
.mac.firefox .WRxWZ69Tv5BhAg.hsPrekSiQjIA0C {
  outline-color: AccentColor;
}
.WRxWZ69Tv5BhAg.clzI3CS7gxHK7_ {
  opacity: 0.4;
}
.s4YGI8ZXqs5aoo {
  display: flex;
  align-items: center;
  padding: var(--ds-space-100, 8px);
}
.cg3DZCWHBQoUTx {
  padding-bottom: var(--ds-space-075, 6px);
  border-top-left-radius: var(--ds-border-radius-300, 12px);
  border-top-right-radius: var(--ds-border-radius-300, 12px);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: var(--accent-background, var(--tr-background-list));
  padding-bottom: var(--ds-space-200, 16px);
  border-radius: inherit;
}
.cg3DZCWHBQoUTx.X5QPAOfAK091Eq:hover {
  background-color: var(--ds-background-accent-gray-subtlest-hovered, #dcdfe4);
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.cg3DZCWHBQoUTx.X5QPAOfAK091Eq:active {
  background-color: var(--ds-background-accent-gray-subtlest-pressed, #b3b9c4);
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.cg3DZCWHBQoUTx.X5QPAOfAK091Eq {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: revert;
  padding: var(--ds-space-150, 12px) var(--ds-space-050, 4px) var(--ds-space-200, 16px);
  overflow: hidden;
  border-radius: inherit;
  cursor: pointer;
  writing-mode: vertical-lr;
}
.NbnQ2xT4zVtfnb {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 14px var(--ds-space-200, 16px) var(--ds-space-150, 12px) var(--ds-space-250, 20px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 20px;
}
.NbnQ2xT4zVtfnb.X5QPAOfAK091Eq {
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-050, 4px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.xg4twDpscIkMg2 {
  display: flex;
  align-items: center;
  padding: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-100, 8px);
  font-weight: var(--ds-font-weight-medium, 500);
}
.KY9Ht59vv0n0go {
  margin-right: var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  color: var(--ds-icon, #44546f);
}
.YT2FiyB_EBYUGL {
  display: flex;
  z-index: 1;
  flex: 1 1 auto;
  flex-direction: column;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-050, 4px);
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
  row-gap: 8px;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  scrollbar-color: var(--ds-background-neutral-hovered, #091e4224) var(--ds-background-neutral, #091e420f);
  scrollbar-width: thin;
}
.YT2FiyB_EBYUGL.vmudxyhv7nLBeg {
  row-gap: var(--ds-space-0, 0);
  margin-top: var(--ds-space-negative-050, -4px);
}
[data-drag-preview] .YT2FiyB_EBYUGL {
  /* stylelint-disable-next-line declaration-no-important */
  overflow-y: hidden !important;
}
.YT2FiyB_EBYUGL[hidden] {
  display: none;
}
.YT2FiyB_EBYUGL::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-button:start:decrement,
.YT2FiyB_EBYUGL::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0 0;
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px);
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0;
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-thumb:vertical,
.YT2FiyB_EBYUGL::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.YT2FiyB_EBYUGL::-webkit-scrollbar-button:end {
  display: block;
  width: 4px;
  height: 4px;
}
@-moz-document url-prefix() {
  .YT2FiyB_EBYUGL {
    margin-right: var(--ds-space-0, 0);
    padding-right: var(--ds-space-100, 8px);
  }
}
.s4YGI8ZXqs5aoo {
  display: flex;
  align-items: center;
  height: 24px;
  padding: var(--ds-space-100, 8px);
  color: var(--ds-text-inverse, #ffffff);
}
.AiZSAWDQyLaI3g {
  box-sizing: border-box;
  height: 24px;
  padding: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-200, 6px);
  background: var(--ds-icon-inverse, #ffffff);
}
.AiZSAWDQyLaI3g span {
  width: 16px;
  height: 16px;
}
.hq4ypU7Xg5wHvN {
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonWrapper": `WRxWZ69Tv5BhAg`,
	"collapsed": `X5QPAOfAK091Eq`,
	"dropTarget": `hsPrekSiQjIA0C`,
	"isDragging": `clzI3CS7gxHK7_`,
	"skeletonJiraHeader": `s4YGI8ZXqs5aoo`,
	"skeletonList": `cg3DZCWHBQoUTx`,
	"skeletonListName": `NbnQ2xT4zVtfnb`,
	"skeletonSyncButton": `xg4twDpscIkMg2`,
	"skeletonRefreshIcon": `KY9Ht59vv0n0go`,
	"skeletonCards": `YT2FiyB_EBYUGL`,
	"hoverGapEnabled": `vmudxyhv7nLBeg`,
	"skeletonJiraIconWrapper": `AiZSAWDQyLaI3g`,
	"skeletonSyncedFrom": `hq4ypU7Xg5wHvN`
};
export default ___CSS_LOADER_EXPORT___;
